import React from 'react';
import InlineQuoteForm from './InlineQuoteForm';

const ServiceHero = (props) => {
  const { title, headline, description, backgroundImage, backgroundVideo, defaultService = '' } = props;

  const scrollToQuote = () => {
    const element = document.querySelector('#quote-section');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const displayHeadline = headline || title;

  return (
    <section 
      className="relative min-h-[80vh] flex items-center bg-cover bg-center bg-no-repeat"
      style={!backgroundVideo ? { backgroundImage: `url(${backgroundImage})` } : undefined}
    >
      {/* Background Video */}
      {backgroundVideo && (
        <video
          autoPlay
          muted
          loop
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
          poster={backgroundImage}
        >
          <source src={backgroundVideo} type="video/mp4" />
        </video>
      )}

      {/* Dark overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/40" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          {/* Left Side - Text Content */}
          <div className="max-w-xl">
            {/* Catchy Headline */}
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-3 leading-tight">
              {displayHeadline}
            </h1>

            {/* Service Name Subtitle */}
            <span className="text-gradient-reflections text-xl sm:text-2xl font-bold block mb-6">
              {title} by Reflections Cleanings
            </span>

            {/* Description */}
            <p className="text-lg text-gray-200 mb-8 leading-relaxed">
              {description}
            </p>

            {/* CTA Button */}
            <div>
              <button
                onClick={scrollToQuote}
                className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-full font-bold text-lg transition-all duration-300 transform hover:scale-105 shadow-lg"
              >
                Request a Quote
              </button>
              <p className="mt-3 text-sm text-gray-300">
                Get within 1 business day
              </p>
            </div>
          </div>

          {/* Right Side - Inline Quote Form (desktop only) */}
          <div className="hidden lg:flex justify-end">
            <InlineQuoteForm defaultService={defaultService} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceHero;
